import { render } from "./GoBottomButton.vue?vue&type=template&id=5349eaac&scoped=true"
import script from "./GoBottomButton.vue?vue&type=script&lang=js"
export * from "./GoBottomButton.vue?vue&type=script&lang=js"

import "./GoBottomButton.vue?vue&type=style&index=0&id=5349eaac&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5349eaac"]])

export default __exports__